import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderModule } from '@cdx/ngx-branding';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, HeaderModule],
})
export class AppComponent {
  widgetVersion: string = __APP_VERSION__;
}
